import React, {Component} from 'react';
// import {Link} from 'react-router-dom';
import {getUser} from "../../../services/index";
import axios from "axios";
import appConfig from "../../../config";
//import {decrementQty, incrementQty, removeFromCart} from "../../../redux/actions";
import {logout} from "../../../redux/actions/authActions";
import {connect} from "react-redux";

class SessionList extends Component {

    constructor() {
        super();
        this.state = {
            city: {},
            bookings: [],
            //doctor: this.props.doctor,
        }
    }

    componentDidMount() {
        let user = getUser();
        if (!user) {
            window.open(`${process.env.PUBLIC_URL}/`, '_self');
        } else {
            this.getBookings(user, this.props.doctor);
            //this.getBookings(this.props.user, doctor);
        }
    }

    printDateTime = (dt) => {
        let x = new Date(dt);
        let dtStr = x.toDateString() + " , " + x.toLocaleTimeString();
        return dtStr;
    }

    getBookings = (user, doctor) => {

        console.log("user booking ", user, doctor);
        // var bookings = [];
        // let filter = {user: user.user.id};
        axios
            .get(appConfig.bookingOrder + '?doctor=' + doctor.id, {
                headers: {
                    Authorization: 'Bearer ' + user.jwt
                }
            })
            .then(response => {
                // Handle success.
                console.log('Well done!');
                console.log('booking data', response.data);
                this.setState({bookings: response.data});
            })
            .catch(error => {
                // Handle error.
                console.log('An error occurred:', error);
            });
    }

    render() {

        const {doctor} = this.props;
        console.log("DOCTOR recived ", doctor);
        const {bookings} = this.state;
        //this.getBookings(this.props.user, doctor);

        return (

            <div className="dashboard">
                {bookings.length > 0 ?
                    // <section className="cart-section section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-06">

                                <table className="table cart-table table-responsive-xs"
                                       style={{border: '1px solid #ddd'}}>
                                    <thead>
                                    <tr className="table-head">
                                        <th scope="col" style={{paddingTop: '20px'}}>Patient</th>
                                        <th scope="col" style={{paddingTop: '20px'}}>Contact</th>
                                        {/*<th scope="col" style={{paddingTop: '20px'}}>Type</th>*/}
                                        <th scope="col" style={{paddingTop: '20px'}}>Type / Time</th>
                                        <th scope="col" style={{paddingTop: '20px'}}>Status</th>
                                        {/*<th scope="col"></th>*/}
                                    </tr>
                                    </thead>
                                    {bookings.map((itm, index) => {
                                        let item = itm.Bookings[0];
                                        console.log("item is ", item);
                                        return (
                                            <tbody key={index}>
                                            <tr>
                                                <td>
                                                        <span style={{textTransform: 'capitalize'}}>
                                                            {itm.user.name}
                                                        </span>
                                                </td>
                                                <td>
                                                        <span>
                                                            {itm.user.phone}<br/>
                                                            {itm.user.email}
                                                        </span>
                                                </td>
                                                {/*<td>*/}
                                                {/*    <span>{item.BookingType}</span>*/}
                                                {/*</td>*/}
                                                <td>
                                                    <span>{item.BookingType} <br/>{this.printDateTime(item.BookingTime)}</span>

                                                </td>
                                                <td>
                                                    <a href={item.BookingURL + "&isAdmin=1"} target="_blank">
                                                        {/*Start Session*/}
                                                        {itm.Status}
                                                    </a>
                                                </td>
                                                {/*<td></td>*/}
                                            </tr>
                                            </tbody>)
                                    })}
                                </table>
                            </div>
                        </div>

                    </div>
                    // </section>
                    :

                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <div>
                                    <div className="col-sm-12 empty-cart-cls text-center">

                                        <h3>
                                            <strong>Doctor's Booking List is Empty</strong>
                                        </h3>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                }

            </div>

        )
    }
}

const mapStateToProps = (state) => ({
    user: state.auth,
})

export default connect(
    mapStateToProps,
    {logout}
)(SessionList)
